import { render, staticRenderFns } from "./ToggleRoltekRequestButton.vue?vue&type=template&id=2384934e&scoped=true"
import script from "./ToggleRoltekRequestButton.vue?vue&type=script&lang=ts"
export * from "./ToggleRoltekRequestButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2384934e",
  null
  
)

export default component.exports